﻿import { createHighlighterCore } from "shiki/core";
import { createJavaScriptRegexEngine } from "shiki/engine/javascript";

import githubLight from "@shikijs/themes/github-light";
import githubDark from "@shikijs/themes/github-dark";

import csharp from "@shikijs/langs/csharp";
import sql from "@shikijs/langs/sql";
import html from "@shikijs/langs/html";
import json from "@shikijs/langs/json";
import css from "@shikijs/langs/css";
import scss from "@shikijs/langs/scss";

let highlighterPromise = null;

const supportedLanguages = [
    "csharp",
    "sql",
    "html",
    "json",
    "css",
    "scss",
    "text"
];

export async function getShikiHighlighter() {
    if (!highlighterPromise) {
        highlighterPromise = createHighlighterCore({
            themes: [
                githubLight,
                githubDark
            ],
            langs: [
                csharp,
                sql,
                html,
                json,
                css,
                scss
            ],
            engine: createJavaScriptRegexEngine()
        });
    }

    return highlighterPromise;
}

export async function preloadShiki() {
    await getShikiHighlighter();
}

export function getShikiTheme() {
    const theme = document.documentElement.getAttribute("data-theme") || "light";
    return theme === "dark" ? "github-dark" : "github-light";
}

export async function highlightCode(code, lang = "text") {
    const highlighter = await getShikiHighlighter();
    const theme = getShikiTheme();

    const normalizedLang = normalizeShikiLang(lang);

    return highlighter.codeToHtml(code || " ", {
        lang: normalizedLang,
        theme
    });
}

export function normalizeShikiLang(lang) {
    const value = String(lang || "text").toLowerCase();

    if (value === "cs" || value === "c#") {
        return "csharp";
    }

    if (supportedLanguages.includes(value)) {
        return value;
    }

    return "text";
}

// import { createHighlighterCore } from "shiki/core";
// import { createJavaScriptRegexEngine } from "shiki/engine/javascript";


// import githubLight from "@shikijs/themes/github-light";
// import githubDark from "@shikijs/themes/github-dark";

// import csharp from "@shikijs/langs/csharp";
// import sql from "@shikijs/langs/sql";
// import html from "@shikijs/langs/html";
// import json from "@shikijs/langs/json";

// let highlighterPromise = null;

// export async function getShikiHighlighter() {
//     if (!highlighterPromise) {
//         highlighterPromise = createHighlighterCore({
//             themes: [githubLight, githubDark],
//             langs: [csharp, sql, html, json],
//             engine: createJavaScriptRegexEngine()
//         });
//     }

//     return highlighterPromise;
// }

// export async function preloadShiki() {
//     await getShikiHighlighter();
// }

// export function getShikiTheme() {
//     const theme = document.documentElement.getAttribute("data-theme") || "light";
//     return theme === "dark" ? "github-dark" : "github-light";
// }

// export async function highlightCode(code, lang = "text") {
//     const highlighter = await getShikiHighlighter();
//     const theme = getShikiTheme();

//     const safeLang = ["csharp", "sql", "html" ,"json"].includes(lang) ? lang : "sql";

//     return highlighter.codeToHtml(code, {
//         lang: safeLang,
//         theme
//     });
// }